import hljs from 'highlight.js';
import 'highlight.js/styles/agate.css';
import xml from 'highlight.js/lib/languages/xml';
import { html as beautifyHtml } from 'js-beautify';

hljs.registerLanguage('html', xml);

export default (config) => ({
    selector: config.selector || 'pre code',
    init() {    
        this.formatAndHighlight();
    },
    formatAndHighlight() {
        document.querySelectorAll(this.selector).forEach(block => {
            const beautified = beautifyHtml(block.textContent, {
                indent_size: 4,
                indent_char: ' ',
                preserve_newlines: true,
                max_preserve_newlines: 2,
                indent_inner_html: true,
                wrap_line_length: 0,
                end_with_newline: true,
                content_unformatted: ['pre', 'code'],
                inline: [],
                brace_style: 'expand'
            });

            const result = hljs.highlight(beautified, { language: 'html' });

            block.innerHTML = result.value;
            block.classList.add('hljs');
        });
    },
});